import { Route, Routes } from "react-router-dom";
import DashboardLayout from "./layout/DashboardLayout";
import Contacts from "./pages/Contacts";
import AddCustomers from "./pages/customerfolder/AddCustomers";
import CustomersTab from "./pages/customerfolder/CustomersTab";
import Dashboard from "./pages/Dashboard";
import AddFranchise from "./pages/franchisesFolder/AddFranchise";
import Franchise from "./pages/franchisesFolder/Franchise";
import FrymeTab from "./pages/FrymeManagement/FrymeTab";
import Frymes from "./pages/frymes/Frymes";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";

const FranchiseDashboard = () => {
  return (
    <Routes>
      <Route path="/" element={<DashboardLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="franchises" element={<Franchise />} />
        <Route path="frymes" element={<Frymes />} />
        <Route path="/frymes-management" element={<FrymeTab />} />
        {/* <Route path="/customers" element={<Customers />} /> */}
        <Route path="/contact-messages" element={<Contacts />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/franchises/add" element={<AddFranchise />} />
        <Route path="/customers/add" element={<AddCustomers />} /> 
        <Route path="/customers" element={<CustomersTab />} />
        <Route path="/profile" element={<Profile />} />
      </Route>
    </Routes>
  );
};

export default FranchiseDashboard;
